import { render, staticRenderFns } from "./PCItemAction.vue?vue&type=template&id=52e870e4&"
import script from "./PCItemAction.vue?vue&type=script&lang=js&"
export * from "./PCItemAction.vue?vue&type=script&lang=js&"
import style0 from "./PCItemAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports